import { Component } from '@angular/core';
import { PWAInstallService } from 'src/app/services/pwa-install.service';

@Component({
  selector: 'app-install-pwa-prompt',
  templateUrl: './install-pwa-prompt.component.html',
  styleUrl: './install-pwa-prompt.component.scss',
})
export class InstallPwaPromptComponent {
  constructor(public pwaInstallService: PWAInstallService) {}
}
